import { useContext } from 'react';
import { UserMutationContext } from '../contexts/userMutationContext';

const useUserMutationContext = () => {
  const context = useContext(UserMutationContext);
  if (!context) {
    throw new Error(
      'useUserMutationContext must be used within a UserMutationContext',
    );
  }
  return context;
};

export default useUserMutationContext;
